<template>
  <div class="bottom-btn">
    <el-button v-preventReClick class="model-table-btn" type="primary" @click="$emit('confirm', true)">{{ $t('保存组件') }}</el-button>
  </div>
</template>

<script>
export default {
  name: 'EamButton',
  props: {},
  data() {
    return {};
  },
  methods: {
  }
};
</script>

<style lang="scss" scoped>
.bottom-btn{
  display: flex;
  align-items: center;
  position: fixed;
  width: 100%;
  height: 60px;
  bottom: 0;
  background: #fff;
  z-index: 10;
  .model-table-btn{
    position: absolute;
    left: 620px;
  }
}
</style>
